<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="커뮤니티" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>커뮤니티</template>

            <div class="page-section__content">
                <div class="sub-tabs">
                    <v-tabs grow hide-slider centered v-model="tab" class="v-tabs--density-compact">
                        <template v-for="(item, index) in items">
                            <tab-quarternary :key="index">
                                {{ item.name }}
                            </tab-quarternary>
                        </template>
                    </v-tabs>
                </div>
            </div>

            <div class="page-section__content">
                <v-tabs-items v-model="tab" class="community-tabs-items">
                    <template v-for="(item, index) in items">
                        <v-tab-item eager :key="index">
                            <div class="image-wrap">
                                <v-img eager :src="item.image">
                                    <v-sheet height="100%" color="transparent" class="pa-18px pa-md-40px">
                                        <v-row class="row--sm flex-column h-100 my-0">
                                            <v-spacer />
                                            <v-col cols="auto">
                                                <tit class="tit--lg white--text line-height-1">
                                                    {{ item.name }}
                                                </tit>
                                            </v-col>
                                            <v-col cols="auto" class="pb-0">
                                                <txt class="txt--lg white--text line-height-11">
                                                    {{ item.text }}
                                                </txt>
                                            </v-col>
                                        </v-row>
                                    </v-sheet>
                                </v-img>
                            </div>
                        </v-tab-item>
                    </template>
                </v-tabs-items>
                <v-row no-gutters justify="end">
                    <v-col cols="auto">
                        <txt class="txt--sm txt--dark mt-8px">* 실제 조성 이미지가 아닌 이해를 돕기 위한 이미지 입니다.</txt>
                    </v-col>
                </v-row>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import TabQuarternary from "@/components/publish/parents/tabs/tab-quarternary.vue";
import SheetSecondary from "@/components/publish/parents/sheets/sheet-secondary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        TabQuarternary,
        SheetSecondary,
        Tit,
        Txt,
    },
    data() {
        return {
            tab: null,
            items: [
                {
                    name: "카페테리아",
                    text: "편안하고 따뜻한 공간에서 각종 행사나 모임을 운영 할 수 있는 공간",
                    image: "/images/sub/complex/community/community-1.jpg",
                },
                {
                    name: "워크스테션",
                    text: "조용하고 쾌적한 환경에서 방해 없이 학업과 업무의 집중도를 높여 자기개발을 할 수 있는 공간",
                    image: "/images/sub/complex/community/community-2.jpg",
                },
                {
                    name: "다이닝룸",
                    text: "2030 거주세대의 라이프스타일에 맞춰 공용 주방기구 및 냉장고, 냉동고 등의 옵션을 제공하여 식음료를 조리 할 수 있는 시크릿한 공간",
                    image: "/images/sub/complex/community/community-3.jpg",
                },
                {
                    name: "공용세탁실",
                    text: "번거로움과 불편함을 최소화 하여 본연의 삶에 집중할 수 있도록 편리하고 효율적인 세탁 및 건조 서비스를 제공하는 공간",
                    image: "/images/sub/complex/community/community-4.jpg",
                },
                {
                    name: "힐링룸",
                    text: "홈트레닝 및 스트레칭 할 수 있는 공간을 설치하여 건강한 생활을 영위하는 데 도움을 주는 공간",
                    image: "/images/sub/complex/community/community-5.jpg",
                },
                {
                    name: "피트니스센터",
                    text: "바쁜 일상 속에서 건강 유지를 위한 곳으로 각종 운동 장비를 갖추고 있어 체력단련을 도와주는 공간",
                    image: "/images/sub/complex/community/community-6.jpg",
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.community-tabs-items {
    position: relative;
    &::before {
        position: absolute;
        display: block;
        content: "";
        top: 55px;
        left: 55px;
        width: 80vw;
        height: 100%;
        background: url(/images/sub/complex/community/marble-background.svg) no-repeat;
        background-size: contain;
        z-index: -1;
    }
}
</style>
